import React, { useEffect } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import { Link } from "react-router-dom";
import { getEmail, getAddress } from "utils/contactInfo";
import { EFFECTIVE_DATE } from "constants/policyDate";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import HeroSectionUpdatedSecond from "components/PublicPagesReusable/HeroSectionUpdatedSecond";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";
import NocBanner from "components/PublicPagesReusable/NocBanner";

const Home = () => {
  useEffect(() => {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();
  }, []);

  const heroWorkTitle = () => {
    return (
      <h1 className="FS48 fw-500 top-section-text">  
          <span className="text-success">Terms </span>& Conditions
      </h1>
    );
  };

  const heroData = {
    badge: "Australia’s Leading English Proficiency Centre",
    title: heroWorkTitle,
    subtitle: `Language Academy Australia Pty Ltd <br/> Effective Date: ${EFFECTIVE_DATE}`,
    
    users: [
      
    ],
    trustText: "",
    
    bottomStatsText: [
      { value: "8",highlight:'+', label: "Years of NAATI Expertise" },
      { value: "50k", highlight:'+', label: "Students' Helped" },
      { value: "10", highlight:'+', label: "Global Locations" },
      { value: "95", highlight:'%', label: "Success Rate" }
    ]
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>Terms and Conditions | LA Language Academy Australia</title>
        <meta name="description" content="Review LA Language Academy's terms and conditions for all services and products. Ensure you understand your rights and responsibilities before enrolling." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/term`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta name="twitter:title" content="Terms and Conditions | LA Language Academy Australia" />
        <meta name="twitter:description" content="Review LA Language Academy's terms and conditions for all services and products. Ensure you understand your rights and responsibilities before enrolling." />
        <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta property="og:url" content={`https://www.languageacademy.com.au/term`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Terms and Conditions | LA Language Academy Australia" />
        <meta property="og:description" content="Review LA Language Academy's terms and conditions for all services and products. Ensure you understand your rights and responsibilities before enrolling." />
        <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>

      <div className="new-design">
        <Header />
        {/* <HeroSectionUpdatedSecond data={heroData} /> */}
         <NocBanner
                  data={heroData}
                  extraClass={"contact-hero-section pte-scoring"}
                  extraClass2={"align-items-start"}
                />
         <div className="w-100 off-white pt-5">  
        <div style={{width:"94%" , marginInline:"auto" , fontFamily: "'Plus Jakarta Sans', sans-serif" }} className="custom-container py-5 ">

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Introduction and Acceptance of Terms</h4>
            <p className="FS16FW500">These Terms and Conditions ("Terms") govern your access to and use of the website <a href="https://www.languageacademy.com.au" className="text-dark text-decoration-underline">languageacademy.com.au</a> and any associated mobile applications, platforms, and services (collectively, the "Platform"), operated by Language Academy Australia Pty Ltd (ABN to be inserted) ("Language Academy," "we," "us," or "our").</p>
            
            <p className="FS16FW500 mt-4">By accessing or using the Platform in any capacity — including browsing, registering an account, enrolling in a course, or purchasing a subscription — you agree to be bound by these Terms. If you do not agree, please discontinue use of the Platform immediately.</p>
            
            <p className="FS16FW500 mt-4">These Terms apply to all products and services offered by Language Academy, including:</p>
            <ul className="list-disc ps-4 FS16FW500">
              <li className="mb-2">In-person classes at our Parramatta centre</li>
              <li className="mb-2">Online live coaching classes</li>
              <li className="mb-2">Video courses and self-paced learning modules
                <ul className="list-disc ps-4 mt-2">
                  <li className="mb-2">Mobile app subscriptions (PTE Practice & AI Mock Tests, NAATI CCL tools)</li>
                </ul>
              </li>
            </ul>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Amendments to Terms</h4>
            <p className="FS16FW500">We reserve the right to amend these Terms at any time. Updated Terms will be posted on the Platform with a revised effective date and will supersede all previous versions. We will not send individual notifications of changes. Your continued use of the Platform after any amendments take effect constitutes your acceptance of the revised Terms.</p>
            
            <p className="FS16FW500 mt-4">We encourage you to review these Terms periodically to stay informed of any updates.</p>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">User Representations and Warranties</h4>
            <p className="FS16FW500">When registering an account or completing any transaction on the Platform, you warrant that:</p>
            <ul className="list-disc ps-4 FS16FW500">
              <li className="mb-2">You are using your actual identity and are at least 18 years of age, or have parental or guardian consent</li>
              <li className="mb-2">All personal information you provide is true, accurate, complete, and current</li>
              <li className="mb-2">You will promptly update your personal information to maintain its accuracy</li>
              <li className="mb-2">You will not use the Platform for any unauthorised or unlawful purpose</li>
              <li className="mb-2">You will not share your account credentials with any third party</li>
            </ul>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Course Enrolment</h4>
            <p className="FS16FW500">Enrolment in any Language Academy course or programme constitutes your agreement to these Terms in full.</p>
            <ul className="list-disc ps-4 FS16FW500 mt-3">
              <li className="mb-3">
                <span className="fw-bold FS20FW500">Eligibility</span>
                <p className="mt-1 mb-0 FS16FW500" >Courses are available to individuals who meet the stated prerequisites for each programme. Language Academy reserves the right to decline or cancel an enrolment at its discretion, including where a student does not meet eligibility criteria.</p>
              </li>
              <li className="mb-3">
                <span className="fw-bold FS20FW500">Confirmation</span>
                <p className="mt-1 mb-0 FS16FW500" >Your enrolment is confirmed only upon receipt of full payment (or the agreed first instalment where applicable) and written confirmation from Language Academy. Places are not guaranteed until payment has been received and confirmed.</p>
              </li>
              <li className="mb-3">
                <span className="fw-bold FS20FW500">Course Schedule</span>    
                <p className="mt-1 mb-0 FS16FW500" >Course schedules, timetables, and locations are published on the Platform and are subject to change. Language Academy will provide reasonable notice of any material changes to scheduled class times. We reserve the right to reschedule or consolidate classes where student numbers or operational requirements make it necessary.</p>
              </li>
            </ul>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Fees and Payment</h4>
            <ul className="list-disc ps-4 FS16FW500 mt-3">
              <li className="mb-4">
                <span className="fw-bold FS20FW500">Course Fees</span>
                
                <p className="mt-1 mb-0 FS16FW500">All course fees are published on the Platform. Fees are displayed in Australian Dollars (AUD) for in-person and online classes delivered in Australia. Fees for app subscriptions and digital products purchased through Indian payment gateways are displayed in Indian Rupees (INR).</p>
              </li>
              <li className="mb-4">
                <span className="fw-bold FS20FW500">Payment Methods</span>
                <p className="mt-1 mb-0 FS16FW500">Language Academy accepts the following payment methods:</p>
                <ul className="list-disc ps-4 mt-2">
                  <li className="mb-2">Online payment by credit or debit card via the Platform</li>
                  <li className="mb-2">Bank transfer / NEFT to Language Academy Australia Pty Ltd (details provided on invoice)</li>
                  <li className="mb-2">Payment through Apple App Store or Google Play for applicable mobile subscriptions</li>
                </ul>
              </li>
              <li className="mb-4">
                <span className="fw-bold FS20FW500">Payment Due</span>
                <p className="mt-1 mb-0 FS16FW500">Full course fees are due at the time of enrolment unless an instalment arrangement has been expressly agreed in writing with Language Academy prior to enrolment. Failure to make payment by the due date may result in your place being forfeited.</p>
              </li>
              <li className="mb-4">
                <span className="fw-bold FS20FW500">Subscription Auto-Renewal</span>
                <p className="mt-1 mb-0 FS16FW500">App and platform subscriptions are offered on an automatically renewing basis unless otherwise stated. Your payment method will be charged at the agreed interval at the then-current rate. You will not receive a separate reminder before each renewal charge is processed.</p>
                <p className="mt-3 mb-0 FS16FW500">You may cancel automatic renewal at any time by:</p>
                <ul className="list-disc ps-4 mt-2">
                  <li className="mb-2">Visiting "Your Subscriptions" in your account dashboard, or</li>
                  <li className="mb-2">Contacting us at <a href="mailto:info@languageacademy.com.au" className="text-dark text-decoration-underline">info@languageacademy.com.au</a> before your next renewal date</li>
                </ul>
                <p className="mt-3 mb-0 FS16FW500">Cancellation takes effect at the end of the current billing cycle. You will retain access until that date, after which your subscription will expire.</p>
              </li>
              <li className="mb-4">
                <span className="fw-bold FS20FW500">External Service Subscriptions</span>
                <p className="mt-1 mb-0 FS16FW500">Where you purchase a subscription via Apple App Store or Google Play ("External Service"), your External Service account will be charged in accordance with the terms disclosed at the point of purchase and the general terms of that External Service provider.</p>
                <p className="mt-3 mb-0 FS16FW500">To cancel an External Service subscription:</p>
                <ul className="list-disc ps-4 mt-2">
                  <li className="mb-2">Apple ID: Settings &rarr; Apple ID &rarr; Subscriptions &rarr; find Language Academy / PTE Practice &rarr; Cancel</li>
                  <li className="mb-2">Google Play: Google Play app &rarr; Menu &rarr; Subscriptions &rarr; find Language Academy &rarr; Cancel</li>
                </ul>
                <p className="mt-3 mb-0 FS16FW500">If you initiate a chargeback or reverse a payment, Language Academy reserves the right to terminate your account immediately. Please contact us at <a href="mailto:info@languageacademy.com.au" className="text-dark text-decoration-underline">info@languageacademy.com.au</a> to resolve any billing concerns before initiating a dispute.</p>
              </li>
              <li className="mb-4">
                <span className="fw-bold FS20FW500">Pricing Changes</span>
                <p className="mt-1 mb-0 FS16FW500">Language Academy reserves the right to change subscription and course pricing at any time with reasonable notice. Your continued use of the service after the effective date of a price change constitutes acceptance of the new pricing.</p>
              </li>
            </ul>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Fees &mdash; No Refund Policy</h4>
            <p className="FS16FW500 fw-700"><em>All fees paid to Language Academy are strictly non-refundable. No refunds will be issued under any circumstances, including but not limited to change of mind, inability to attend, or change in personal circumstances.</em></p>
            
            <p className="FS16FW500 mt-4">By completing payment and enrolling in any course, programme, or subscription, you acknowledge and agree that:</p>
            <ul className="list-disc ps-4 FS16FW500 mt-3">
              <li className="mb-2">All fees are paid on a non-refundable basis</li>
              <li className="mb-2">No refund will be issued if you choose to withdraw from a course, miss classes, or cease using the Platform</li>
              <li className="mb-2">No refund will be issued in the event of technical difficulties on your device or internet connection</li>
              <li className="mb-2">Unused class sessions or subscription periods are non-refundable and do not carry forward</li>
            </ul>

            <p className="FS16FW500 mt-4">This policy applies to all services, including in-person classes, online coaching, video courses, and mobile app subscriptions.</p>
            
            <p className="FS16FW500 mt-4">For any concerns regarding your enrolment or billing, please contact us at <a href="mailto:info@languageacademy.com.au" className="text-dark text-decoration-underline">info@languageacademy.com.au</a> and we will do our best to assist you.</p>

            <ul className="list-disc ps-4 FS16FW500 mt-4">
              <li className="mb-4">
                <span className="fw-bold FS20FW500">Subscription Pause</span>
                <p className="mt-2 mb-0 FS16FW500">While all fees are non-refundable, students with a current subscription may request a pause of up to one (1) month where a valid reason is provided. A valid reason is limited to medical or health circumstances, supported by documentation (e.g. a medical certificate) if requested by Language Academy.</p>
                <p className="mt-2 mb-0 FS16FW500">To request a pause, contact us at <a href="mailto:info@languageacademy.com.au" className="text-dark text-decoration-underline">info@languageacademy.com.au</a> with your reason and any supporting documentation. Pauses are granted at Language Academy's sole discretion. Your subscription period will be extended by the approved pause duration. No more than one pause may be granted per subscription term.</p>
              </li>
              <li className="mb-4">
                <span className="fw-bold FS20FW500">Subscription Conversion</span>
                <p className="mt-2 mb-0 FS16FW500">If you wish to switch from one subscription plan to another, Language Academy can apply the remaining value of your current subscription as a credit toward your new plan. The credit will be calculated on a pro-rata basis based on the unused portion of your current billing cycle at the time of conversion.</p>
                <p className="mt-2 mb-0 FS16FW500">To request a conversion, contact us at <a href="mailto:info@languageacademy.com.au" className="text-dark text-decoration-underline">info@languageacademy.com.au</a>. Conversions are processed manually and are subject to Language Academy's approval. No cash refund will be issued as part of a conversion &mdash; the credit applies to the new plan only.</p>
              </li>
            </ul>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Purchases and Automatically Renewing Subscriptions <span className="text-muted fs-6 fw-normal">(For Mobile APP)</span></h4>
            <p className="FS16FW500 mt-3">
              PTE Practice &amp; AI Mock Tests may offer products and services for purchase through the Apple App Store,
              Google Play Store, or other external services authorised by PTE Practice &amp; AI Mock Tests (each, an
              "External Service," and any purchase made thereon, an "External Service Purchase"). PTE Practice &amp; AI Mock Tests
              may also offer products and services for purchase via credit card, debit card, UPI, or
              other payment methods on the Platform ("Internal Purchases").
            </p>
            <p className="FS16FW500 mt-3">
              Subscriptions may be offered as automatically renewing unless otherwise stated. If you cancel
              your subscription, you will continue to have access to its benefits until the end of your current
              billing cycle, after which it will expire. Cancelling a subscription does not remove your profile
              from the Services. If you wish to fully delete your account, you must do so in accordance with
              Section (Account Termination).
            </p>

            <ul className="list-disc ps-4 FS16FW500 mt-4">
              <li className="mb-4">
                <h4 className="fw-600">External Service Purchases and Subscriptions</h4>
                <p className="FS16FW500 mt-2">
                  When you make a purchase via an External Service (e.g., Apple ID or Google Play), your
                  External Service account will be charged in accordance with the terms disclosed at the time of
                  purchase and the general terms of your External Service provider. Taxes may apply based on
                  your location.
                </p>
                <p className="FS16FW500 mt-2">
                  If your External Service Purchase includes an automatically renewing subscription, your
                  External Service account will continue to be charged at the agreed rate and interval until you
                  cancel. To cancel, you must manage your subscription directly within your External Service
                  account — even if you have deleted the PTE Practice &amp; AI Mock Tests app or deactivated your profile.
                </p>
                <p className="FS16FW500 mt-2">For example:</p>
                <ul className="list-disc ps-4 mt-1">
                  <li className="mb-2"><strong>Apple ID:</strong> Go to Settings &gt; iTunes &amp; App Stores &gt; Apple ID &gt; View Apple ID &gt; Subscriptions and cancel PTE Practice &amp; AI Mock Tests.</li>
                  <li className="mb-2"><strong>Google Play:</strong> Go to Google Play app &gt; Menu &gt; My Apps &gt; Subscriptions, find PTE Practice &amp; AI Mock Tests, and cancel.</li>
                </ul>
                <p className="FS16FW500 mt-2">
                  If you initiate a chargeback or reverse a payment through an External Service, PTE Practice &amp; AI Mock Tests
                  reserves the right to terminate your account immediately. Should the chargeback be
                  overturned, please contact PTE Practice &amp; AI Mock Tests Support. Certain users may be entitled to a
                  refund in accordance with Section Refunds.
                </p>
              </li>

              <li className="mb-4">
                <h4 className="fw-600">Internal Purchases and Subscriptions</h4>
                <p className="FS16FW500 mt-2">
                  If you make an Internal Purchase, you agree to pay the amount displayed along with any
                  applicable taxes. You authorise PTE Practice &amp; AI Mock Tests to charge your provided payment method
                  ("Payment Method"), and we may correct any billing errors, even if payment has already been
                  requested or received.
                </p>
                <p className="FS16FW500 mt-2">
                  If your subscription includes automatic renewal, your Payment Method will be charged at the
                  agreed interval unless cancelled. You can manage or cancel subscriptions by visiting Settings
                  &gt; My Orders within the Platform.
                </p>
                <p className="FS16FW500 mt-2">
                  You may update your Payment Method in the settings section. If we are unable to process your
                  payment, you authorise us to attempt again using updated information from your provider. You
                  remain responsible for any unpaid charges.
                </p>
                <p className="FS16FW500 mt-2">
                  Chargebacks or reversed payments may result in immediate termination of your account. If a
                  reversal is overturned, please contact PTE Practice &amp; AI Mock Tests Support. Refund eligibility is outlined
                  in Section Refunds.
                </p>
              </li>

              <li className="mb-4">
                <h4 className="fw-600">Virtual/Digital Items</h4>
                <p className="FS16FW500 mt-2">
                  PTE Practice &amp; AI Mock Tests may offer limited-use, non-transferable, non-sublicensable, revocable
                  licences for virtual or digital items ("Virtual Items") through its Platform. These items are for
                  entertainment or functionality purposes within the Services and do not represent monetary value
                  or real-world currency.
                </p>
                <p className="FS16FW500 mt-2">
                  You may only purchase Virtual Items through PTE Practice &amp; AI Mock Tests or its authorised partners.
                  PTE Practice &amp; AI Mock Tests retains ownership of all Virtual Items, and you acknowledge that their
                  perceived value may change or be revoked at any time, with or without notice. PTE Practice &amp; AI Mock Tests
                  has no liability for such changes and prohibits the transfer or resale of Virtual Items.
                </p>
                <p className="FS16FW500 mt-2">
                  All Virtual Item purchases and redemptions are final and non-refundable. Deleting your account
                  or account termination (voluntary or involuntary) does not entitle you to compensation or refund
                  for unused Virtual Items.
                </p>
              </li>

              <li className="mb-4">
                <h4 className="fw-600">Refunds</h4>
                <p className="FS16FW500 mt-2">
                  The purchase and sale of subscriptions is considered complete upon successful payment.
                  However, PTE Practice &amp; AI Mock Tests provides a refund window of up to three (3) working days from the
                  date of payment, provided the subscription has not been used in any manner. "Use" of a
                  subscription includes but is not limited to sending or receiving messages, viewing other user
                  profiles, and updating your own profile or account details.
                </p>
                <p className="FS16FW500 mt-2">
                  If none of the above actions have been taken, you may request a full refund within the 3-day
                  window. Once approved, PTE Practice &amp; AI Mock Tests will issue the refund immediately, though your bank
                  or card issuer may take 5–15 days to reflect the refund in your account or statement.
                </p>
                <p className="FS16FW500 mt-2">
                  If your subscription remains unused, you may let it expire naturally without further renewal.
                  Subscription balances do not carry real-world monetary value and do not accrue interest or
                  stored value. Upon account deletion, PTE Practice &amp; AI Mock Tests reserves the right to redeem or forfeit
                  any unused subscription balance.
                </p>
                <p className="FS16FW500 mt-2">
                  If PTE Practice &amp; AI Mock Tests terminates your account due to a violation of this Agreement, you will not
                  be entitled to any refund.
                </p>
              </li>
            </ul>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Account Termination <span className="text-muted fs-6 fw-normal">(For Mobile APP)</span></h4>
            <p className="FS16FW500 mt-3">
              You may deactivate your account at any time by logging into the PTE Practice &amp; AI Mock Tests Website or
              App, navigating to the "Settings" section, and following the instructions to deactivate or delete
              your account. Please note that deactivating your account does not cancel any subscriptions
              purchased through an External Service (such as Apple App Store or Google Play). You must manage
              or cancel such subscriptions directly through your External Service account to avoid continued
              billing.
            </p>
            <p className="FS16FW500 mt-3">
              PTE Practice &amp; AI Mock Tests reserves the right to investigate, suspend, or permanently terminate your
              account at any time, at its sole discretion, with or without prior warning. Grounds for such
              action include, but are not limited to:
            </p>
            <ul className="list-disc ps-4 FS16FW500 mt-2">
              <li className="mb-2">Violation of these Terms;</li>
              <li className="mb-2">Misuse of the Services;</li>
              <li className="mb-2">Engaging in inappropriate, fraudulent, abusive, or unlawful behaviour, whether on or off the Platform;</li>
              <li className="mb-2">Uploading prohibited content or attempting to bypass moderation tools.</li>
            </ul>
            <p className="FS16FW500 mt-3">
              In some cases, we may issue a warning before termination, but we are not obligated to do so.
              Termination may be immediate if the violation is deemed severe or if required by law or policy.
            </p>
            <p className="FS16FW500 mt-3">
              If your account is terminated by you or by PTE Practice &amp; AI Mock Tests for any reason, this Agreement
              remains in effect and you will not be entitled to any refund or compensation for any purchases
              or unused subscriptions.
            </p>
            <p className="FS16FW500 mt-3">
              PTE Practice &amp; AI Mock Tests may, under certain circumstances and at its sole discretion, allow reactivation
              of accounts that were previously deactivated or terminated. This is assessed subject to
              eligibility and platform policies.
            </p>
            <p className="FS16FW500 mt-3">
              Your personal data, including your content and communications, will be maintained or deleted in
              accordance with our Privacy Policy, and residual data may be retained to comply with legal
              obligations, enforce our policies, or resolve disputes.
            </p>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Attendance and Missed Classes</h4>
            <p className="FS16FW500">Students are expected to attend all scheduled classes for their enrolled programme. Language Academy does not provide makeup classes or credits for missed sessions.</p>
            
            <p className="FS16FW500 mt-4">Where Language Academy cancels a class due to circumstances within our control, we will endeavour to reschedule the session or provide access to equivalent course materials at no additional charge.</p>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Subscription Plans &mdash; Mobile App and Platform</h4>
            <p className="FS16FW500">Language Academy offers the following paid subscription tiers for its digital learning platform and mobile app. Prices for Australian users are in AUD; prices for Indian users are in INR. Current pricing is published on the Platform and may be updated with notice.</p>
            
            <ul className="list-disc ps-4 FS16FW500 mt-3">
              <li className="mb-4">
                <span className="fw-bold FS20FW500">Silver Plan</span>
                <p className="mt-2 mb-2">The Silver Plan includes:</p>
                <ul className="list-disc ps-4 mt-2">
                  <li className="mb-2">Unlimited AI scoring for all PTE question types</li>
                  <li className="mb-2">Full access to exam questions</li>
                  <li className="mb-2">Access to the latest templates and prediction files</li>
                  <li className="mb-2">Unlimited sectional, full, and comprehensive mock tests with scoring</li>
                </ul>
              </li>
              <li className="mb-4">
                <span className="fw-bold FS20FW500">Gold Plan</span>
                <p className="mt-2 mb-2">The Gold Plan includes everything in the Silver Plan, plus:</p>
                <ul className="list-disc ps-4 mt-2">
                  <li className="mb-2">Access to reading explanation videos (VIP)</li>
                  <li className="mb-2">Full access to premium strategy videos (VIP)</li>
                  <li className="mb-2">Full access to the detailed video course (VIP)</li>
                </ul>
              </li>
            </ul>

            <p className="FS16FW500 mt-4">Current plan pricing and billing frequencies are listed on the Platform at <a href="https://www.languageacademy.com.au" className="text-dark text-decoration-underline">languageacademy.com.au</a>. Prices are subject to change with reasonable notice.</p>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Account Termination</h4>
            <p className="FS16FW500">Language Academy reserves the right to suspend or terminate your account at any time, with or without notice, if you breach these Terms or engage in conduct that is harmful, unlawful, or disruptive to other students or staff.</p>
            
            <p className="FS16FW500 mt-4">Upon termination, your access to course materials and the Platform will cease. Termination does not entitle you to a refund of any fees paid.</p>
            
            <p className="FS16FW500 mt-4">If you wish to delete your account, please contact <a href="mailto:info@languageacademy.com.au" className="text-dark text-decoration-underline">info@languageacademy.com.au</a>. Cancelling a subscription does not automatically delete your account.</p>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Intellectual Property</h4>
            <p className="FS16FW500">All content on the Platform &mdash; including course materials, videos, templates, practice questions, mock tests, written resources, logos, and software &mdash; is the exclusive property of Language Academy Australia Pty Ltd or its licensors and is protected by Australian and international copyright, trademark, and intellectual property laws.</p>

            <p className="FS16FW500 mt-4">You are granted a limited, non-exclusive, non-transferable licence to access and use the Platform content solely for your personal, non-commercial study purposes. You must not:</p>
            <ul className="list-disc ps-4 FS16FW500 mt-3">
              <li className="mb-2">Reproduce, distribute, publicly display, or create derivative works from any Platform content</li>
              <li className="mb-2">Share, sell, or sub-licence your account or any course materials to any third party</li>
              <li className="mb-2">Record, screenshot, or screen-capture live classes or video content without prior written consent</li>
              <li className="mb-2">Use any content for commercial purposes or to train artificial intelligence models</li>
            </ul>
          </div>

          <div className="py-4 refund-policy-border">
                           <h4 className="fw-600">Privacy</h4>
                           <p className="FS16FW500">Language Academy collects, stores, and uses your personal information in accordance with our Privacy Policy, available at languageacademy.com.au/privacy. By using the Platform, you consent to the collection and use of your information as described in the Privacy Policy.</p>
                         </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Disclaimers and Limitation of Liability</h4>
            <p className="FS16FW500">The Platform and all course materials are provided on an "as is" basis. While we strive for accuracy and quality, Language Academy makes no warranties, express or implied, regarding:</p>
            <ul className="list-disc ps-4 FS16FW500 mt-3">
              <li className="mb-2">The accuracy, completeness, or suitability of any course content for your specific purposes</li>
              <li className="mb-2">Guaranteed outcomes, scores, or results from any course or programme</li>
              <li className="mb-2">Uninterrupted or error-free access to the Platform</li>
            </ul>
            <p className="FS16FW500 mt-4">Language Academy's total liability to you for any claim arising from your use of the Platform or any service shall not exceed the total amount paid by you in the three (3) months preceding the claim. Language Academy is not liable for indirect, incidental, special, or consequential damages of any kind.</p>
          </div>

          <div className="py-4 refund-policy-border">
            <h4 className="fw-600">Governing Law</h4>
            <p className="FS16FW500">These Terms are governed by and construed in accordance with the laws of New South Wales, Australia. Any disputes arising under these Terms shall be subject to the exclusive jurisdiction of the courts of New South Wales.</p>
            
            <p className="FS16FW500 mt-4">Nothing in these Terms limits any rights you may have under applicable Australian Consumer Law.</p>
          </div>

          <div className="py-4">
               <h4 className="fw-600">Contact Us</h4>
               <p style={{color:"#686868"}} className="FS16FW500">For any questions about this Privacy Policy, please contact us:</p>

               <div className="d-flex flex-wrap mt-4" style={{ gap: "20px 40px" }}>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Inquiry</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">
                     <a href={`mailto:${getEmail()}`} className="text-dark text-decoration-underline">{getEmail()}</a>
                   </p>
                 </div>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Call Us</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">
                     <a href="tel:+61426230061" className="text-dark text-decoration-none">+61 426 230 061</a>
                   </p>
                 </div>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Visit Us</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">{getAddress()}</p>
                 </div>
                 <div style={{ flex: "1 1 220px", minWidth: "220px" }} className="mb-3">
                   <p className="text-secondary FS16FW500 mb-1">Website</p>
                   <p className="FS16FW500 fw-600 text-dark mb-0">
                     <a href="https://www.languageacademy.com.au" target="_blank" rel="noopener noreferrer" className="text-dark text-decoration-underline">https://www.languageacademy.com.au</a>
                   </p>
                 </div>
               </div>
               <p className="text-secondary FS16FW500 mb-1">Language Academy Australia Pty Ltd reserves the right to modify, suspend, or discontinue any aspect of the Platform or its services at any time with reasonable notice.</p>
              </div>
             </div>
            </div>
                                <div className="custom-container mt-2" style={{ padding: "40px 0 30px 0" , width:"94%" }}>
                                   <CtaBanner
                                     title="Ready to Test Your "
                                     highlight="Level?"
                                     buttonText="Book Free Consultation"
                                     onClick={() => { const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop')); modal.show(); }}
                                     rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
                                     btnText="Take Free Mock Test"
                                     subTitle={"Take a free mock test and understand your current standing before enrolling."}
                                   />
                                 </div>
      </div>
      <Footer />
    </React.Fragment>
  );
};

export default Home;